module.exports = __webpack_public_path__ + "static/media/warning.d716fafc.gif";